import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface RoleRestrictedRouteProps {
  children: React.ReactNode;
  restrictedRoles?: string[];
}

export function RoleRestrictedRoute({ children, restrictedRoles = ['recruiter'] }: RoleRestrictedRouteProps) {
  const { profile, isLoadingInitial } = useAuth();

  if (isLoadingInitial) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-white/60" />
      </div>
    );
  }

  if (profile?.company_role && restrictedRoles.includes(profile.company_role)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}